// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xngTooltipStyles } from "@hardwoods/App/Components/XngTooltip/Style";
import { CustomZIndex } from "@hardwoods/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@hardwoods/XDL/types";
import { color } from "@hardwoods/XDL/Utilities";
import { AccordionStyle } from "@insite/mobius/Accordion";
import { AccordionSectionHeader } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { PageStyle } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

export default {
    css: css`
        @media print {
            ${AccordionStyle} {
                break-inside: avoid;
            }

            ${AccordionSectionHeader} button {
                display: flex !important;
            }

            .hide-on-print {
                display: none !important;
            }

            .xng-tooltip-content-wrapper {
                display: none !important;
            }

            .acquire-launcher-wrapper,
            .aio-widget-frame {
                display: none !important;
            }
        }

        .tippy-tooltip {
            ${xngTooltipStyles.main?.css}
        }

        main${PageStyle} {
            overflow: visible;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            overflow: visible;
                        `,
                        css`
                            overflow: visible;
                        `,
                    ],
                    "max",
                )}
        }

        #browser-not-support-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            background-color: ${color("text.main", 0.75)};
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 2558452;
            > div {
                background: white;
                border-radius: 5px;
                padding: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            a {
                color: ${color("text.link")};
                margin-left: 5px;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
